// extracted by mini-css-extract-plugin
module.exports = {"customGrid":"App_customGrid__3ICjr","customRow":"App_customRow__20aIn","customColumn":"App_customColumn__3NS47"};